const SITE_METADATA = {
  title: "Codefumes | Innovate, Experiment, Deploy 🚀",
  url: "https://codefumes.com",
  image: "/images/logo_new_512.webp",
  description:
    "We develop innovative solutions for all your tech projects using cutting edge technologies that will meet the needs of future. At codefumes, we experiment with different tech stacks to bring out the most efficient and scalable software solutions. Do you have an awesome project idea for your brand? Get your FREE QUOTE now!",
}

export default SITE_METADATA
